const API_PREFIX_LEGACY = '_mrkt';
const API_PREFIX = 'api/v1';

export { API_PREFIX_LEGACY, API_PREFIX };
